import { render, staticRenderFns } from "./AssetTypeList.vue?vue&type=template&id=924bcf1a&scoped=true"
import script from "./AssetTypeList.vue?vue&type=script&lang=js"
export * from "./AssetTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924bcf1a",
  null
  
)

export default component.exports